import { Component, OnInit, Renderer2, AfterViewInit, ElementRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';

import { LoginService, CountriesService, routeActivationEndData$, RouteData } from '@whitehatgaming/shared';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import * as wzshared from '@whitezipmedia/whitezip-libs/index';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, AfterViewInit {
  @ViewChild('cookieBannerContainer') public cookieBannerContainer!: ElementRef;

  public headerVisible$: Observable<boolean>;
  public footerVisible$: Observable<boolean>;
  public cookieHtml: string = '';
  public country: string = '';
  public loggedIn: boolean = false;

  constructor(private login: LoginService, private countries: CountriesService, private router: Router, private renderer: Renderer2) {
    this.loggedIn = this.login.loggedIn;

    this.countries.getCountry().subscribe((data: { value: string }) => {
      this.country = data.value.toLowerCase();
    });

    wzshared.componentService.init('cookieConsent').then((componentResponse: { view: string }) => {
      this.cookieHtml = `<div><link rel="stylesheet" type="text/css" href="/css/cookie-notice.css">${componentResponse.view}<script async type="text/javascript" src="/js/gtm-tags.js"></script></div>`;
    });

    wzshared.basicInfoService.init().then((basicInfoData: any) => {
      (window as any).basicInfo = basicInfoData;
    });
  }

  public ngOnInit(): void {
    this.headerVisible$ = routeActivationEndData$(this.router).pipe(map((data: RouteData) => !data?.appHeaderHidden));
    this.footerVisible$ = routeActivationEndData$(this.router).pipe(map((data: RouteData) => !data?.appFooterHidden));
  }

  public ngAfterViewInit(): void {
    const observer: MutationObserver = new MutationObserver((mutations: MutationRecord[]) => {
      mutations.forEach((mutation: MutationRecord) => {
        if (mutation.type === 'childList') {
          this.executeScripts(mutation.target as HTMLElement);
        }
      });
    });

    observer.observe(this.cookieBannerContainer.nativeElement, {
      childList: true,
      subtree: true,
    });
  }

  public executeScripts(target: HTMLElement): void {
    const scripts: NodeListOf<HTMLScriptElement> = target.querySelectorAll('script');

    scripts.forEach((script: HTMLScriptElement) => {
      const newScript: HTMLScriptElement = document.createElement('script');

      newScript.type = 'text/javascript';

      if (script.src) {
        newScript.src = script.src;
      } else {
        newScript.innerHTML = script.innerHTML;
      }

      this.renderer.appendChild(document.head, newScript);
    });
  }
}

export {};
